import React, {useCallback, useEffect, useMemo, useState} from 'react';
import {useAppDispatch, useAppSelector} from "../../../../../hooks/redux";
import {getUser} from "../../../../../store/selectors/authSelector";
import styles from './ProfileLink.module.css'
import {CaretDownOutlined, CaretUpOutlined, UserOutlined} from "@ant-design/icons";
import Popover from "../../../../Utils/Popover/Popover";
import DropMenu from "../DropMenu/DropMenu";
import ProfileMenu_Mobile from "./ProfileMenu_Mobile/ProfileMenu_Mobile";
import {getTextByLanguage} from "../../../../../enums/utils/getTextByLanguage";
import {UIText} from "../../../../../enums/UIText/UIText";
import {getLanguage} from "../../../../../store/selectors/appSelector";
// import {useNavigate} from "react-router-dom";
import {authSlice} from "../../../../../store/reducers/AuthSlice";
import {IProfileMenu} from "../../../../../models/IProfileMenu";



const ProfileLink = () => {

    const language = useAppSelector(getLanguage)
    // const navigate = useNavigate()
    const dispatch = useAppDispatch()

    const profileMenuData = useMemo((): IProfileMenu[] => {
        return [
            {
                title: getTextByLanguage(UIText.nav.profile, language),
                path: '/profile'
            },
            {
                title: getTextByLanguage(UIText.actions.logout, language),
                callback: () => dispatch(authSlice.actions.logout())
            }
        ]
    }, [dispatch, language])

    const user = useAppSelector(getUser)

    const isFullName = Boolean(user?.firstName && user?.secondName && user?.lastName)
    const initials = `${user?.lastName && user?.lastName[0].toUpperCase() + user?.lastName.slice(1)} 
    ${user?.firstName && user?.firstName[0].toUpperCase()}.${user?.secondName && user?.secondName[0].toUpperCase()}.`

    const [isOpenPopover, setIsOpenPopover] = useState<boolean>(false)
    const [isProfileMenuShow, setIsProfileMenuShow] = useState<boolean>(false)


    const closePopoverClickOverPopover = useCallback((e: any) => {
        const wrapper = e.target.closest(`.${styles.profileLinkWrapper}`)
        const icon = e.target.closest(`.${styles.iconPopOver}`)
        if (!wrapper && !icon) {
            setIsOpenPopover(false)
            document.body.removeEventListener('click', closePopoverClickOverPopover)
        }
    }, [])




    useEffect(() => {
        if (isOpenPopover) {
            document.body.addEventListener('click', closePopoverClickOverPopover)
        } else {
            document.body.removeEventListener('click', closePopoverClickOverPopover)
        }
    }, [closePopoverClickOverPopover, isOpenPopover])

    return (
        <div>


            <div className={styles.profileLinkWrapper} onClick={() => setIsOpenPopover((prevValue) => !prevValue)}>
                <p className={styles.profileLink}>
                    {user && isFullName ? initials : user?.email} {isOpenPopover ?
                    <CaretUpOutlined className={styles.iconPopOver}/> :
                    <CaretDownOutlined className={styles.iconPopOver}/>}
                </p>
                <Popover isOpen={isOpenPopover} setIsOpen={setIsOpenPopover} >
                    <DropMenu menuData={profileMenuData}/>
                </Popover>
            </div>


            <UserOutlined className={styles.profileLink__mobile} onClick={() => setIsProfileMenuShow(true)}/>
            {/* eslint-disable-next-line react/jsx-pascal-case */}
            <ProfileMenu_Mobile
                menuData={profileMenuData}
                setIsMenuShown={setIsProfileMenuShow}
                isMenuShown={isProfileMenuShow}/>
        </div>

    );
};

export default ProfileLink;